import "components/Layout/FrontMain/FrontMain.scss";
import { PropsWithChildren } from "react";

const FrontMain = ({ children, className }: PropsWithChildren<{ className?: string }>) => (
    <main className={`front-main ${className || ""}`}>
        <div className="front-main__content">{children}</div>
    </main>
);

export default FrontMain;
